import Handlebars from "handlebars-template-loader/runtime";

Handlebars.registerHelper("version", function() {
  return new Handlebars.SafeString(process.env.VERSION);
});
